"use client";

import { ArrowDownRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourFinancialFuture() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.3
  });
  const headline = "Secure your future.";
  const letters = headline.split("");
  return <section data-section-id="578" id="secure-your-financial-future" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-40 px-6">
      {}
      <div aria-hidden="true" className="absolute top-6 left-4 md:top-10 md:left-12 select-none pointer-events-none font-default font-bold leading-none text-7xl md:text-9xl text-accent/20">
        §
      </div>

      {}
      <div aria-hidden="true" className="absolute bottom-8 right-6 md:bottom-12 md:right-16 select-none pointer-events-none text-accent">
        <ArrowDownRight className="size-16 md:size-24" strokeWidth={1.5} />
      </div>

      <div className="relative max-w-7xl mx-auto text-center">
        <h2 ref={ref} className="font-default font-bold leading-[0.85] tracking-tighter text-6xl sm:text-7xl md:text-8xl lg:text-9xl" aria-label={headline}>
          {letters.map((char, i) => <span key={i} data-index={i} className="inline-block transition-all ease-out" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(0.5em)",
          transitionDuration: "600ms",
          transitionDelay: `${i * 45}ms`,
          whiteSpace: char === " " ? "pre" : "normal"
        }}>
              {char}
            </span>)}
        </h2>

        <p className="mt-8 md:mt-10 text-base md:text-xl max-w-2xl mx-auto font-default text-muted-foreground">
          Professional tax planning and compliance services designed to provide clarity and long-term financial stability for you and your business.
        </p>

        <div className="mt-10 md:mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="rounded-lg h-14 px-8 text-base font-medium shadow-md hover:opacity-90 bg-accent text-accent-foreground">
            <Link to="#">Start Your Consultation</Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="rounded-lg h-14 px-8 text-base font-medium bg-transparent hover:bg-accent/10 border-2 border-accent text-accent">
            <Link to="#">Explore Our Services</Link>
          </Button>
        </div>
      </div>
    </section>;
}